// SidebarPresets.js
// Centralized sidebar items for different admin roles
import {
  BarChart3 as BarChart3Icon,
  Briefcase as BriefcaseIcon,
  Users as UsersIcon,
  FileText as FileTextIcon,
} from 'lucide-react';

export function getSidebarItemsForRole(role) {
  switch (role) {
    case 'company-admin':
      return companyAdminItems;
    case 'cluster-admin':
      return clusterAdminItems;
    case 'unit-admin':
      return unitAdminItems;
    default:
      return defaultItems;
  }
}

export const companyAdminItems = [
  { id: 'details', label: 'Company Details', icon: BarChart3Icon },
  { id: 'recruiters', label: 'Recruiters', icon: UsersIcon },
  { id: 'job-posts', label: 'Job Posts', icon: BriefcaseIcon },
  { id: 'admins', label: 'Admins', icon: UsersIcon },
  { id: 'clusters', label: 'Clusters', icon: BriefcaseIcon },
  { id: 'units', label: 'Units', icon: BriefcaseIcon },
  { id: 'structure', label: 'Structure', icon: FileTextIcon },
];

export const clusterAdminItems = [
  { id: 'details', label: 'Details', icon: BarChart3Icon },
  { id: 'recruiters', label: 'Recruiters', icon: UsersIcon },
  { id: 'job-posts', label: 'Job Posts', icon: BriefcaseIcon },
  { id: 'admins', label: 'Admins', icon: UsersIcon },
  { id: 'units', label: 'Units', icon: BriefcaseIcon },
  { id: 'structure', label: 'Structure', icon: FileTextIcon },
];

export const unitAdminItems = [
  { id: 'details', label: 'Details', icon: BarChart3Icon },
  { id: 'admins', label: 'Admins', icon: UsersIcon },
  { id: 'recruiters', label: 'Recruiters', icon: UsersIcon },
  { id: 'job-posts', label: 'Job Posts', icon: BriefcaseIcon },
  { id: 'structure', label: 'Structure', icon: FileTextIcon },
];

const defaultItems = [
  { id: 'details', label: 'Details', icon: BarChart3Icon },
];
